import { CheckInTagDto, ExportJobRequestDto, ExportJobResponseDto } from '@careapp-group/ng-sdk';
import { CaEntityActionsFactory } from '../entity-state/entity-actions-factory';

class DataExportJobsActions extends CaEntityActionsFactory<
  ExportJobResponseDto,
  ExportJobRequestDto
> {
  constructor() {
    super(`DataExportJobsActions`);
  }
}

export const DataExportJobs = new DataExportJobsActions();
